import Page from "../pages/Signup";
import { pageMeta } from "../lib/meta";
export const meta = () => pageMeta({ title: "Create your account | Gazar", description: "Create a free Gazar account.", path: "/signup" });
export default function Signup() { return <Page />; }
